import React from 'react'
import constants from 'constants/constants'
import styled from 'styled-components'

export const S = {
    Wrapper: styled.div`
        margin-top: -28px;
        width: 100%;
        height: 1200px;
    `
}

const Resources = () => (
    <S.Wrapper>
        <iframe
            width="100%"
            height="100%"
            title="resources"
            src={`${constants.contextualHelpBaseUrl}lite/resources/`}
            frameBorder="0"
        />
    </S.Wrapper>
)

export default Resources
